<template>
  <div class="page page-blue"></div>
</template>

<script>
import jwt from "jwt-decode";

export default {
  name: "WebViewAuth",
  data() {
    return {
      msg: "",
      jwt: ""
    };
  },
  created() {
    // Получаем jwt-токен
    this.msg = jwt(window.location.hash);
    return this.proceedLogin();
  },
  methods: {
    proceedLogin() {
      try {
        let body = new FormData();
        body.append("user_id", this.msg.user_id);
        body.append("device_id", this.msg.device_id);
        this.axios
          .post(process.env.VUE_APP_API_ROOT + "/webviewauth", body, {
            headers: {
              "X-CSRFToken": this.$store.state.security.csrf
            }
          })
          .then(r => {
            if (r.data.status === "error") {
              console.error(r.data.message);
              return this.$router.push("/403");
            }
            const data = r.data.result;
            this.$store.commit("setUser", data.abo);
            this.$store.commit("setTemplates", data.templates);
            this.$store.commit("setPage", data.page);
            this.$router.push("/");
          });
      } catch (e) {
        this.$router.push("/401");
      }
    }
  }
};
</script>

<style scoped></style>
